import { PageViewEvent } from '@shopify/events';
import { onDocumentReady } from '@theme/utilities';

onDocumentReady(
  function dispatchPageViewEvent() {
    /** @type {HTMLElement | null} */
    const templateElement = document.querySelector('main[data-template]');
    const template = templateElement?.dataset.template || '';

    // -- Page --
    document.dispatchEvent(
      new PageViewEvent({
        page: {
          template,
          title: document.title,
          url: window.location.href,
        },
      })
    );
  },
  { once: true }
);

onDocumentReady(
  function keepEllaHeaderFixed() {
    const headerGroup = document.getElementById('header-group');
    const headerSection = headerGroup?.querySelector('.section-ella-style-header');

    if (!headerGroup || !(headerSection instanceof HTMLElement)) return;

    if (!document.getElementById('nomitail-fixed-ella-header-runtime')) {
      const style = document.createElement('style');
      style.id = 'nomitail-fixed-ella-header-runtime';
      style.textContent = `
        #header-group:has(.section-ella-style-header) {
          min-height: var(--ella-style-header-height, 0px);
        }

        #header-group > .section-ella-style-header,
        #header-group > .shopify-section.section-ella-style-header {
          position: fixed !important;
          top: 0 !important;
          right: 0;
          left: 0;
          width: 100%;
          z-index: 1000;
        }

        html {
          scroll-padding-top: var(--ella-style-header-height, 0px);
        }
      `;
      document.head.appendChild(style);
    }

    const setHeaderHeight = () => {
      const height = Math.ceil(headerSection.getBoundingClientRect().height || 0);

      if (!height) return;

      document.documentElement.style.setProperty('--ella-style-header-height', `${height}px`);
      document.body.style.setProperty('--ella-style-header-height', `${height}px`);
      headerGroup.style.minHeight = `${height}px`;
    };

    const fixHeader = () => {
      headerSection.style.setProperty('position', 'fixed', 'important');
      headerSection.style.setProperty('top', '0', 'important');
      headerSection.style.setProperty('right', '0');
      headerSection.style.setProperty('left', '0');
      headerSection.style.setProperty('width', '100%');
      headerSection.style.setProperty('z-index', '1000');
      setHeaderHeight();
    };

    fixHeader();
    window.requestAnimationFrame(fixHeader);
    window.setTimeout(fixHeader, 600);

    if (!headerSection.dataset.ellaFixedHeaderReady && 'ResizeObserver' in window) {
      headerSection.dataset.ellaFixedHeaderReady = 'true';
      new ResizeObserver(setHeaderHeight).observe(headerSection);
    }

    window.addEventListener('resize', setHeaderHeight);
  },
  { once: true }
);
